<header>
  <app-navbar *ngIf="showNavbar"></app-navbar>
</header>

<main role="main" id="component" class="container-lg justify-content-center align-items-center">
  <router-outlet></router-outlet>
</main>
